export default class ClearRecentCustomers {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.recentCustomers.set([]);
  }
}
